import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaChalkboardTeacher, FaGlobe, FaInstagram } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdCheck, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import logo from '../assets/logo.png'

export default function Footer(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-dark"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px",
					borderTop: "1px solid var(--secondaryColor)"
				}}
			>
				<div className="container">
					<div className="row">
						
						<div className="col-md-4">

							<img
								src={logo}
								style={{
									width: "100%",
									height: "auto",
									display: "block",
									marginTop: "45px"
								}}
								className="bg-light"
							/>

							<h6
								className="font-light mt-2"
								style={{
									fontSize: "14px"
								}}
							>
								<span className="font-bold">Caremed Gas Ltd</span> has become one of the fastest growing trading establishments involved in the buying and selling of consumable and non-consumable products in Tanzania. Our vision is to facilitate the Tanzanian Health Sector by importing quality products and serve the populous in an ethical way.
							</h6>

			
						</div>

						<div className="col-md-4">
							<h6
								className="main-section-title"
							>
								Address
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
								
								className="font-bold text-light"
							>
								CAREMED GAS LTD <br/>
								P.O.BOX 16405 DAR ES SALAAM <br/>
								LOCATION: KIJITONYAMA <br/>
								BLOCK NO: 64 <br/>
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
								className="font-bold text-light"
							>
								Opening Hours: <br/>
								Mon-Fri 08:30-15:30 Sat and Sun
							</h6>
							
						</div>

						<div className="col-md-4">
							<h6
								className="main-section-title"
							>
								Reach Out
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
								className="font-bold text-light"
							>
								Email: <span>info@caremedgaslimited.com</span> <br/>
								Phone: <span>+255705998527</span>
							</h6>

							<div
								style={{
									fontSize: "14px",
								}}
								className="font-bold text-light d-flex gap-2"
							>
								<h6
									style={{
										fontSize: "14px",
										padding: "10px",
										cursor: "pointer",
									}}
									onClick={() => {
										window.open("https://www.instagram.com/caremed_gas_ltd?igsh=ZzBiamU5M3FwaGRm&utm_source=qr", "_blank");
								
									}}
									className="font-bold text-light"
								>
									<FaInstagram size={32}/>
								</h6>

								<h6
									style={{
										fontSize: "14px",
										padding: "10px",
										cursor: "pointer",
									}}
									onClick={() => {
										window.open("https://wa.me/255705998527", "_blank");
								
									}}
									className="font-bold text-light"
								>
									<MdWhatsapp size={32}/> 
								</h6>
								
								<h6
									style={{
										fontSize: "14px",
										padding: "10px",
										cursor: "pointer",
									}}
									onClick={() => {
										
										window.open('mailto:info@caremedgaslimited.com', '_blank')
										
									}}
									className="font-bold text-light"
								>
									<MdEmail size={32}/>
								</h6>
															
							</div>

							

							
						</div>

						<div className="col-md-12 text-center font-bold">
							<hr/>
							<h6
								style={{
									fontSize: "14px",
									paddingTop: "30px"
								}}
								className="text-light"
							>
								&copy;Caremed Gas LTD - {getCurrentYear()}
							</h6>

						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
